import moment from 'moment';

class OverviewApiService {
  constructor(HttpService, SessionService) {
    'ngInject';

    this.HttpService = HttpService;
    this.SessionService = SessionService;
  }

  getHistory(payload) {
    if (payload.from) {
      payload.from = moment(payload.from, 'YYYY-MM-DD').format();
    }

    if (payload.to) {
      payload.to = moment(payload.to, 'YYYY-MM-DD').format();
    }

    const queryParams = this.HttpService.buildQueryParamsFromPayload(payload);
    return this.HttpService.get('/' + this.SessionService.getLocale() + `/overview/transaction-history?${queryParams}`);
  }
}

export default OverviewApiService;



// WEBPACK FOOTER //
// ./client/app/api/services/overview.api.service.js